<template>
    <div class="container block_screen">
        <div class="">
            <div class="first_page">
                <div class="container--small">
                    <i class="icon-Product-Icon_HDM_Suite main-icon f-blue"></i>
                    <p class="promo-text">
                      Willkommen zum
                    </p>
                    <h1>Paragon Festplatten Manager (FM)</h1>
                    <p class="desc">
                      Mit dieser All-In-One-Lösung zur Datenverwaltung lassen sich Daten auf der Festplatte mühelos
                      zuordnen, verwalten und sichern.
                      Mit FM können Sie folgende Aktionen ausführen:
                    </p>
                    <ul class="hdm_list">
                        <li><a @click.prevent="changeScreen(90)" class="tellus gotolast"
                               href="#">Sichern/wiederherstellen</a></li>
                        <li><a class="tellus gotolast" href="#" @click.prevent="changeScreen(30)">Partitionen verwalten</a></li>
                        <li><a @click.prevent="changeScreen(53)" class="tellus gotolast" href="#">Daten/Betriebssystem migrieren</a></li>
                        <li><a @click.prevent="changeScreen(65)" class="tellus gotolast" href="#">Daten löschen/bereinigen</a></li>
                        <li><a @click.prevent="changeScreen(76)" class="tellus gotolast" href="#">Festplatten-Image erstellen</a></li>
                    </ul>
                    <p class="desc">
                      Wählen Sie ein Szenario und schauen Sie, welche Lösung Festplatten Manager bereit hält!
                    </p>
                    <div class="btn_right">
                        <a href="" @click.prevent="changeScreen(100)"
                           class="btn btn_orange">Überspringen</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import {mapMutations} from 'vuex'
  export default {
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
